import React, { useState } from "react";
import { Alert, Button, Divider, Form, Input, Space, Typography } from "antd";
import offerService from "../../../../../Service/offer.service";
import cartService from "../../../../../Service/cart.service";

const CouponCodeSection: React.FC = () => {
  const [form] = Form.useForm();
  const [alertStatus, setAlertStatus] = useState<"success" | "error" | null>(
    null,
  );
  const [alertMessage, setAlertMessage] = useState<string | null>(null);

  const validateCouponCode = async (value: string) => {
    const couponCheck = await offerService.applyCoupon(value);
    return couponCheck;
  };

  const handleCouponApply = async (couponCode: string) => {
    try {
      const response = await validateCouponCode(couponCode);
      if (response && response?.status) {
        cartService.applyOffer(response?.data._id);
        setAlertStatus("success");
        setAlertMessage(`${couponCode} applied successfully`);
      } else {
        setAlertStatus("error");
        setAlertMessage(`${response.message}`);
      }
    } catch (error) {
      console.error("Invalid coupon code: ", error);
      setAlertStatus("error");
      setAlertMessage(`Invalid coupon code`);
    }
  };

  const handleRemoveCoupon = async () => {
    cartService.removeOffer();
    setAlertMessage(null);
    setAlertStatus(null);
    form.resetFields();
  };

  return (
    <div className="coupon-code-content">
      <Typography.Title level={5} style={{ margin: 0 }}>
        Apply Discount
      </Typography.Title>
      <Typography.Text
        type="secondary"
        style={{ fontSize: 12, fontWeight: 500 }}
      >
        Enter coupon code to get discount instantly
      </Typography.Text>
      <Divider orientation="center" style={{ margin: 0 }} />
      <Form
        form={form}
        onFinish={({ couponCode }: any) => handleCouponApply(couponCode)}
        layout="inline"
      >
        <Space size={0} className="apply-discount__form-space">
          <Form.Item
            name="couponCode"
            rules={[{ required: true, message: "Please enter a coupon code" }]}
            className="apply-discount__form-item"
          >
            <Input
              placeholder="XXX-YYY-ZZZ"
              className="apply-discount__input"
            />
          </Form.Item>
          <Space align="center" className="apply-discount__button-space">
            {!alertStatus && (
              <Button type="primary" size="middle" htmlType="submit">
                APPLY
              </Button>
            )}
            {alertStatus && (
              <Button type="primary" size="middle" onClick={handleRemoveCoupon}>
                Remove Coupon
              </Button>
            )}
          </Space>
        </Space>
      </Form>

      {alertStatus && (
        <Alert message={alertMessage} type={alertStatus} banner />
      )}
    </div>
  );
};

export default CouponCodeSection;
